import { API_STATES } from "@/helpers";

const state = {
  alertsGetState   : API_STATES.NOT_REQUESTED,
  alertsGetError   : null,
  alertDeleteState : API_STATES.NOT_REQUESTED,
  alertDeleteError : null,
  alertCreateState : API_STATES.NOT_REQUESTED,
  alertCreateError : null,
  alerts           : [],
  alertUpdateState : API_STATES.NOT_REQUESTED,
  alertUpdateError : null,
  alert            : {}
};

export default state;
